import { useRouterPerformance } from '@/hooks/useRouterPerformance';

/**
 * Composant wrapper pour les optimisations de performance qui dépendent du router
 * Doit être placé à l'intérieur du BrowserRouter
 */
export const RouterPerformanceWrapper = (): null => {
  useRouterPerformance();
  return null;
};
